export const EASTER_EGGS: Record<string, readonly string[]> = {
  Patrick: [
    'ELITE-KOMMANDANT ERKANNT: Gegnerische Teams beantragen vorsorglich einen Balance-Patch.',
    'SYSTEMWARNUNG: Patricks taktische Überlegenheit überschreitet die zulässigen LAN-Grenzwerte.',
    'AIM-GOD ONLINE: Trefferquote konnte nicht gemessen werden – Sensoren waren nicht schnell genug.',
  ],
  Pauli: [
    'PAULI ONLINE: Eigene Panzer wurden vorsorglich als akut gefährdete Spezies eingestuft.',
    'C&C-DIAGNOSE: Fahrzeugverluste gelten laut Pauli weiterhin als ausgeklügeltes Ablenkungsmanöver.',
    'R6-SENSORIK: Magazin leer, Wand beeindruckt, Gegner gesundheitlich unauffällig.',
  ],
  Bertl: [
    'BERTL ERKANNT: Das R6-Fadenkreuz beantragt wegen chronischer Erfolglosigkeit Versetzung.',
    'ZIELERFASSUNG FEHLGESCHLAGEN: Gegner können Bertls Sichtlinie weiterhin gefahrlos überqueren.',
    'MUNITIONSBERICHT: 120 Schuss abgegeben, drei Lampen und ein Türrahmen erfolgreich neutralisiert.',
  ],
  Jakob: [
    'JAKOB ONLINE: Aurora-Bomber gestartet – Rückflug wurde aus Budgetgründen nicht eingeplant.',
    'C&C-LUFTWAFFE MELDET: Aurora erneut geopfert. Jakob nennt es strategische Einweglogistik.',
    'GEFREITER JAKOB EINGETROFFEN: Generäle verstecken vorsorglich ihre Flugfelder.',
  ],
  Lukas: [
    'LUKAS ONLINE: Die Ratte hat bereits eine Freundschaftsanfrage und die Schlüssel zur Burg geschickt.',
    'STRONGHOLD-WARNUNG: Berittene Bogenschützen entfernen sich selbstständig aus Lukas’ Kommandozone.',
    'BURGBERICHT: Mauern stehen noch – Fachleute rechnen daher mit einer außergewöhnlich frühen Spielphase.',
  ],
  Stefan: [
    'STEFAN ERKANNT: Das Stronghold-Tutorial wird sicherheitshalber automatisch eingeblendet.',
    'RANG BESTÄTIGT: Knappe Stefan darf heute unter Aufsicht bereits einen eigenen Holzfäller setzen.',
    'BURGAUFBAU-ASSISTENT AKTIV: Pfeile markieren jetzt, wo Mauern normalerweise hingehören.',
  ],
  Thomas: [
    'THOMAS ONLINE: Stronghold-Tutorial und R6-Zielhilfe streiten sich um die höchste Priorität.',
    'R6-DIAGNOSE: Ziel erfasst, Schuss abgegeben, Zusammenhang zwischen beiden Ereignissen nicht nachweisbar.',
    'KNAPPENSTATUS BESTÄTIGT: Thomas erhält heute erneut beaufsichtigten Zugriff auf das Burgtor.',
  ],
  Uli: [
    'ULI ONLINE: Campingplatz reserviert, Zelt aufgebaut und K/D-Anzeige vorsorglich abgedeckt.',
    'R6-WARNUNG: Uli bewegt sich! Fehlalarm – er suchte nur eine noch dunklere Ecke zum Campen.',
    'EINGABEGERÄT ERKANNT: FIFA mit Maus. Der technische Support hat kommentarlos gekündigt.',
  ],
};

export function getPlayerEasterEgg(playerName: string, index?: number): string {
  const name = playerName.trim();
  const canonicalName = Object.keys(EASTER_EGGS).find(
    (player) => player.toLocaleLowerCase('de-AT') === name.toLocaleLowerCase('de-AT'),
  );

  if (!canonicalName) {
    return `GASTPROFIL ${name || 'UNBEKANNT'} GELADEN: Noch keine belastenden LAN-Akten gefunden.`;
  }

  const comments = EASTER_EGGS[canonicalName];
  const selectedIndex = index ?? Math.floor(Math.random() * comments.length);
  return comments[((selectedIndex % comments.length) + comments.length) % comments.length];
}
